import React, { Component } from 'react';

import Board from './components/board';

import './main.css';

class App extends Component {
  render() {
    return (
      <Board />
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js